import { getRequiredElement } from "../../Shared/Utilities/attributes";

export const updateProgressBar = (progress: number) => {
  const progressBarContainer = getRequiredElement<HTMLElement>(
    document,
    "[data-progress-bar]",
    "Progress bar container not found."
  );

  const progressBar = getRequiredElement<HTMLProgressElement>(
    progressBarContainer,
    "progress",
    "Progress bar not found."
  );

  const currentProgress = getRequiredElement<HTMLElement>(
    progressBarContainer,
    "[data-current-progress]",
    "Current progress not found."
  );

  currentProgress.innerHTML = progress.toString();

  progressBar.value = progress;
};
